import { render } from "./PasswordResetComponent.vue?vue&type=template&id=3685837a&scoped=true"
import script from "./PasswordResetComponent.vue?vue&type=script&lang=js"
export * from "./PasswordResetComponent.vue?vue&type=script&lang=js"

import "./PasswordResetComponent.vue?vue&type=style&index=0&id=3685837a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3685837a"]])

export default __exports__